import { render, staticRenderFns } from "./DevelopedSymptoms.vue?vue&type=template&id=d16c81a6&"
import script from "./DevelopedSymptoms.vue?vue&type=script&lang=js&"
export * from "./DevelopedSymptoms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports